import { Card, CardContent, CardHeader } from "@material-ui/core";
import __ from "lodash";
import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import accountManagement from "../../../apis/accountManagement";
import { CONFIG } from "../../../config";
import LoaderModal from "../../../components/modal/LoaderModal";
import "../../../components/dashboard/content/report/tryout/circlebar.css";
// import "../../../components/dashboard/content/report/tryout/reportcbt.css";
import { Gap, GridInline, LabelTitle, Line, ProgressBar } from "../../../components/Global";
// import "./ReportAgcu.css";

class ReportAgcu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            showIndikator: false,
            //param: this.props.location.state,
            param: this.props.match.params,
            dataMapel: [],
            data: {},
            dataLs: {},
            dataPsi: {},
            listIndikator: [],
            dataSekolah: null,
        };
    }

    async componentDidMount() {
        document.title = "Report CBT";
        this.getReportCbt();
    }

    getReportCbt = async () => {
        this.setState({ isFetching: true });
        const { param } = this.state;
        let qString = {
            tipeCbt: param.tipeCbt,
            idJadwalCbt: param.idJadwalCbt,
            idSekolah: param.idSekolah,
            idKelas: param.idKelas,
        };
        if (param.idKelasParalel !== "null") {
            qString = { ...qString, idKelasParalel: param.idKelasParalel };
        }
        if (param.tahunAjaranFirst !== "null" && param.tahunAjaranSecond !== "null") {
            qString = { ...qString, tahunAjaran: param.tahunAjaranFirst + "/" + param.tahunAjaranSecond };
        }

        if (param.tipeCbt != "SBMPTN") {
            // ====================== !!! NON SBMPTN !!! ========================
            const response = await accountManagement
                .get(CONFIG.REPORT_CBT_GET, {
                    params: qString,
                })
                .catch(function (error) {
                    console.log(error);
                });

            if (response) {
                if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        dataMapel: response.data.data.dataMapel,
                        data: response.data.data,
                        dataLs: response.data.data.dataLs,
                        dataPsi: response.data.data.dataPsi,
                    });
                }
                this.setState({ isFetching: false });
            } else {
                this.setState({ isFetching: false });
            }
        } else {
            // ====================== !!! SBMPTN !!! ========================
            const response = await accountManagement
                .get(CONFIG.REPORT_CBT_REKAP_SBMPTN, {
                    params: qString,
                })
                .catch(function (error) {
                    console.log(error);
                });

            if (response) {
                if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        dataMapel: response.data.data.dataMapel,
                        data: response.data.data,
                        dataLs: response.data.data.dataLs,
                        dataPsi: response.data.data.dataPsi,
                        dataSekolah: response.data.data.dataSekolah,
                    });
                }
                this.setState({ isFetching: false });
            } else {
                this.setState({ isFetching: false });
            }
        }
    };

    loadIndikator = async () => {
        this.setState({ listIndikator: [] });
        const { showIndikator, param } = this.state;

        if (showIndikator) {
            console.log("HIDE");
            this.setState({ showIndikator: !showIndikator });
        } else {
            console.log("SHOW");
            this.setState({ isFetching: true });
            let qString = {
                tipeCbt: param.tipeCbt,
                idJadwalCbt: param.idJadwalCbt,
                idSekolah: param.idSekolah,
                idKelas: param.idKelas,
            };
            if (param.idKelasParalel !== "null") {
                qString = { ...qString, idKelasParalel: param.idKelasParalel };
            }
            const response = await accountManagement
                .get(CONFIG.REPORT_CBT_LOAD_INDIKATOR, {
                    params: qString,
                })
                .catch(function (error) {
                    console.log(error);
                });

            if (response) {
                if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        listIndikator: response.data.data.data,
                        showIndikator: !showIndikator,
                    });
                }
                this.setState({ isFetching: false });
            }
        }
    };

    onPrint = () => {};

    renderIndikator(list) {
        return (
            <tbody>
                {list.map((indi, i) => (
                    <tr>
                        <td>Soal {i + 1}</td>
                        <td>{indi.namaIndikator}</td>
                        <td className="text-center">{indi.tuntas}</td>
                        <td className="text-center">{indi.tidakTuntas}</td>
                    </tr>
                ))}
            </tbody>
        );
    }

    renderParentMapel() {
        if (!__.isEmpty(this.state.dataMapel)) {
            return this.state.dataMapel.map((data, i) => (
                <>
                    <Col key={i} sm={4}>
                        <Card>
                            <CardHeader title={data.namaMapel} className="box-title" style={{ marginBottom: "0 !important" }}></CardHeader>
                            <CardContent>
                                <div className="table-responsive-sm text-center">
                                    <table className="table table-sm table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th rowSpan="2" style={{ width: "40%" }}>
                                                    KATEGORI
                                                </th>
                                                <th colSpan="2" style={{ borderBottom: "none!important" }}>
                                                    JUMLAH
                                                </th>
                                            </tr>
                                            <tr>
                                                <th>SISWA</th>
                                                <th>%</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.match.params.tipeCbt === "SBMPTN" && (
                                                <tr>
                                                    <td>SANGAT RENDAH</td>
                                                    <td>{data.katSgtRendah}</td>
                                                    <td>{data.prosenSgtRendah}%</td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td>RENDAH</td>
                                                <td>{data.katRendah}</td>
                                                <td>{data.prosenRendah}%</td>
                                            </tr>

                                            <tr>
                                                <td>SEDANG</td>
                                                <td>{data.katSedang}</td>
                                                <td>{data.prosenSedang}%</td>
                                            </tr>

                                            <tr>
                                                <td>TINGGI</td>
                                                <td>{data.katTinggi}</td>
                                                <td>{data.prosenTinggi}%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </CardContent>
                        </Card>
                    </Col>
                    <br />
                </>
            ));
        }
    }

    render() {
        const { data, dataMapel, listIndikator, dataLs, dataPsi, dataSekolah } = this.state;
        require("./ReportAgcu.css");
        return (
            <div>
                <LoaderModal isFetching={this.state.isFetching} />
                <div className="report-page">
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>01</span>
                        </div>
                        <div className="pnl-date">
                            Tanggal Asesmen : {data.tglEvent}
                        </div>
                    </div>
                    <div className="header-first-page-agcu">

                        {this.state.param.tipeCbt === "AGCU" ? (
                            <div className="text-header">
                                <div className="title-header" style={{ color: '#015E56' }}>ACADEMIC GENERAL CHECK UP</div>
                                <div className="label-sub-tit">
                                    <sapn className="sub-title-header" style={{ color: '#FFF' }}>Assessment School Report</sapn>
                                </div>
                            </div>
                        ) : (
                            <div className="text-header">
                                <div className="title-header">TRY OUT</div>
                                <div className="sub-title-header">Assessment School Report</div>
                            </div>
                        )}
                        <div className="image-header">
                            <div className="logo-eduprime">
                                <img src="https://eduprime.co.id/static/images/LogoEduprimePutih.png" width={"100%"} alt="" />
                            </div>
                            <div className="logo-cbt">{this.state.param.tipeCbt === "AGCU" ? <img src="/assets/image/logoAGCU.png" style={{ width: "100%" }} alt="" /> : <img src="/assets/image/uss.png" style={{ width: "100%" }} alt="" />}</div>
                        </div>
                    </div>
                    <Gap height={40} />
                    {/* <Line color={"#C4161C"} /> */}
                    <div className="pnl-profile">
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-sekolah.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <spann className="label-profile-name">Nama Sekolah</spann>
                                <p className="label-profile-value">{data.dataSekolah}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-kelas.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <spann className="label-profile-name">Kelas</spann>
                                <p className="label-profile-value">{data.dataKelas}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-jum-peserta.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <spann className="label-profile-name">Jumlah Siswa</spann>
                                <p className="label-profile-value">{data.totalPeserta}</p>
                            </div>
                        </div>

                    </div>
                    {/* <Gap height={20} /> */}

                    <div style={{ color: "#000", fontSize: 18, fontWeight: 600, marginBottom: 20 }}>Statistik & Ketuntasan</div>

                    <div
                        style={{
                            display: "inline-block",
                            width: "100%",
                            marginBottom: 1,
                            backgroundColor: "#BEF264",
                            border: "#E9ECEF 1px solid",
                            borderTopLeftRadius: 20,
                            borderTopRightRadius: 20,
                            padding: "20px",
                        }}
                    >
                        <div style={{ display: "inline-block", width: "18%", paddingLeft: 5 }}>Program Studi</div>
                        {/* <div style={{ display: "inline-block", width: "21%" }}>Ketuntasan</div> */}
                        <div style={{ display: "inline-block", width: "72%" }}>Statistik</div>
                    </div>
                    <hr style={{ margin: 0 }} />
                    <table className="table table-hover">
                        <tbody>
                            {dataMapel.map((itemMapel, i) => (
                                <tr>
                                    <td>{itemMapel.namaMapel}</td>
                                    <td width="85%">
                                        <table width={"100%"}>
                                            <tr style={{ border: 0 }}>
                                                <td style={{ border: 0 }}>
                                                    <div style={{ display: "inline-block", width: "100%", marginBottom: 5 }}>
                                                        <div style={{ display: "inline-block", width: "10%" }}>
                                                            <img src="/assets/image/tinggi.png" width={"100%"} alt="" />
                                                        </div>
                                                        {this.props.match.params.tipeCbt === "SBMPTN" ? (
                                                            <div style={{ display: "inline-block", width: "90%", paddingLeft: 5 }}>Tinggi : &gt; 650.01</div>
                                                        ) : (
                                                            <div style={{ display: "inline-block", width: "90%", paddingLeft: 5 }}>Tinggi : 75,1-100</div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {itemMapel.prosenTinggi}% - {itemMapel.katTinggi} Siswa
                                                    </div>
                                                </td>
                                                <td style={{ border: 0 }}>
                                                    <div style={{ display: "inline-block", width: "100%", marginBottom: 5 }}>
                                                        <div style={{ display: "inline-block", width: "10%" }}>
                                                            <img src="/assets/image/sedang.png" width={"100%"} alt="" />
                                                        </div>
                                                        {this.props.match.params.tipeCbt === "SBMPTN" ? (
                                                            <div style={{ display: "inline-block", width: "90%", paddingLeft: 5 }}>Sedang : 500.01-650.00</div>
                                                        ) : (
                                                            <div style={{ display: "inline-block", width: "90%", paddingLeft: 5 }}>Sedang : 50,1-75,0</div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {itemMapel.prosenSedang}% - {itemMapel.katSedang} Siswa
                                                    </div>
                                                </td>
                                                <td style={{ border: 0 }}>
                                                    <div style={{ display: "inline-block", width: "100%", marginBottom: 5 }}>
                                                        <div style={{ display: "inline-block", width: "10%" }}>
                                                            <img src="/assets/image/rendah.png" width={"100%"} alt="" />
                                                        </div>
                                                        {this.props.match.params.tipeCbt === "SBMPTN" ? (
                                                            <div style={{ display: "inline-block", width: "90%", paddingLeft: 5 }}>Rendah : 300.01-500.00</div>
                                                        ) : (
                                                            <div style={{ display: "inline-block", width: "90%", paddingLeft: 5 }}>Rendah : 25,1-50,0</div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {itemMapel.prosenRendah}% - {itemMapel.katRendah} Siswa
                                                    </div>
                                                </td>
                                                <td style={{ border: 0 }}>
                                                    <div style={{ display: "inline-block", width: "100%", marginBottom: 5 }}>
                                                        <div style={{ display: "inline-block", width: "10%" }}>
                                                            <img src="/assets/image/sangat-rendah.png" width={"100%"} alt="" />
                                                        </div>
                                                        {this.props.match.params.tipeCbt === "SBMPTN" ? (
                                                            <div style={{ display: "inline-block", width: "90%", paddingLeft: 5 }}>Sangat Rendah : 0.00-300.00</div>
                                                        ) : (
                                                            <div style={{ display: "inline-block", width: "90%", paddingLeft: 5 }}>Sangat Rendah : 0-25,0</div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {itemMapel.prosenSangatRendah}% - {itemMapel.katSangatRendah} Siswa
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {Object.keys(dataLs).length != 0 && (
                    <div className="report-page">
                        <div className="header-second-page">
                            <GridInline width={"100%"}>
                                <GridInline width={"80%"}>
                                    {this.props.match.params.tipeCbt === "AGCU" ? (
                                        <LabelTitle label={"Assessment Report Academic General Check-Up"} size={22} bolder={700} color={"#fff"} />
                                    ) : (
                                        <LabelTitle label={"Seleksi Nasional Berdasarkan Tes (SNBT)"} size={22} bolder={700} color={"#fff"} />
                                    )}
                                    <LabelTitle label={dataSekolah} size={18} bolder={500} color={"#fff"} />
                                </GridInline>
                            </GridInline>
                        </div>

                        <Gap height={30} />
                        <div style={{ border: "#E9ECEF 1px solid", backgroundColor: "#F8F9FA", padding: "15px 5% 15px 5%", borderTopLeftRadius: 20, borderTopRightRadius: 20 }}>
                            <LabelTitle label={"Learning Style Test"} size={15} bolder={600} color={"#000"} />
                        </div>
                        <div style={{ border: "#E9ECEF 1px solid", padding: "15px 5% 15px 5%" }}>
                            {dataLs.map((itemLs, i) => (
                                <>
                                    <GridInline width={"100%"}>
                                        <GridInline width={"50%"}>
                                            <GridInline width={"70%"}>Learning Style Test : {itemLs.analisa.jenisPenilaian}</GridInline>
                                            <GridInline width={"30%"}>
                                                {itemLs.dominasi === true && <div style={{ backgroundColor: "#008000", width: "50%", color: "#fff", textAlign: "center", padding: 4, borderRadius: 10 }}>Dominasi</div>}
                                            </GridInline>
                                            <Gap height={2} />
                                            <LabelTitle label={"Jumlah Siswa : " + itemLs.jumlahSiswa} bolder={"normal"} size={14} />
                                            <Gap height={5} />
                                            <GridInline width={"17%"}>
                                                <LabelTitle label={"Presentase :"} bolder={"normal"} size={14} />
                                            </GridInline>
                                            <GridInline width={"40%"} marginBottom={"-13px"}>
                                                <ProgressBar ratio={100} progressColor={"#EF233C"} progressValue={itemLs.prosentase} heightBar={20} />
                                            </GridInline>
                                            <GridInline width={"3%"}></GridInline>
                                            <GridInline width={"20%"} marginBottom={"-3px"}>
                                                <LabelTitle label={itemLs.prosentase + "%"} bolder={"normal"} size={14} />
                                            </GridInline>
                                            <Gap height={20} />
                                            <LabelTitle label={"Saran Pengelolaan Kelas"} bolder={600} size={15} />
                                            <Gap height={5} />
                                            <GridInline width={"2%"}></GridInline>
                                            <GridInline width={"80%"}>
                                                <div dangerouslySetInnerHTML={{ __html: itemLs.analisa.saranGuru }} />
                                            </GridInline>
                                        </GridInline>
                                        <GridInline width={"50%"} verticalAlign={"top"}>
                                            <LabelTitle label={"Karakteristik"} bolder={600} size={15} />
                                            <Gap height={5} />
                                            <GridInline width={"2%"}></GridInline>
                                            <GridInline width={"80%"}>
                                                <div dangerouslySetInnerHTML={{ __html: itemLs.analisa.analisis }} />
                                            </GridInline>
                                        </GridInline>
                                    </GridInline>
                                    <Gap height={15} />
                                    <Line color={"#E9ECEF"} />
                                    <Gap height={15} />
                                </>
                            ))}
                            
                        </div>
                    </div>
                )}

                {Object.keys(dataPsi).length != 0 && (
                    <div className="report-page">
                        <div className="header-second-page">
                            <GridInline width={"100%"}>
                                <GridInline width={"80%"}>
                                    {this.props.match.params.tipeCbt === "AGCU" ? (
                                        <LabelTitle label={"Assessment Report Academic General Check-Up"} size={22} bolder={700} color={"#fff"} />
                                    ) : (
                                        <LabelTitle label={"Seleksi Nasional Berdasarkan Tes (SNBT)"} size={22} bolder={700} color={"#fff"} />
                                    )}
                                    <LabelTitle label={dataSekolah} size={18} bolder={500} color={"#fff"} />
                                </GridInline>
                            </GridInline>
                        </div>

                        <Gap height={30} />
                        <div style={{ color: "#000", fontSize: 18, fontWeight: 600, marginBottom: 20 }}>Psychology Potential Test</div>
                        <div
                            style={{
                                display: "inline-block",
                                width: "100%",
                                marginBottom: 1,
                                backgroundColor: "#BEF264",
                                border: "#E9ECEF 1px solid",
                                borderTopLeftRadius: 20,
                                borderTopRightRadius: 20,
                                padding: "15px 5% 15px 5%",
                            }}
                        >
                            <div style={{ display: "inline-block", width: "30%", paddingLeft: 5 }}>Program Studi</div>
                            <div style={{ display: "inline-block", width: "30%" }}>Rata-Rata</div>
                            <div style={{ display: "inline-block", width: "40%" }}>Kategori</div>
                        </div>
                        <hr style={{ margin: 0 }} />
                        <Gap height={20} />
                        <GridInline width={"100%"} paddingLeft={"5%"}>
                            <GridInline width={"30%"}>
                                Adversity Quotient
                                <br />
                                <small>(Daya Juang)</small>
                            </GridInline>
                            <GridInline width={"27%"}>{dataPsi.skorAq}</GridInline>
                            <GridInline width={"35%"}>
                                <GridInline width={"5%"}>
                                    <img src="/assets/image/tinggi.png" width={"100%"} alt="" />
                                </GridInline>
                                <GridInline width={"2%"}></GridInline>
                                <GridInline width={"90%"}>{dataPsi.labelAq}</GridInline>
                            </GridInline>
                        </GridInline>
                        <Gap height={10} />
                        <Line color={"#E9ECEF"} />
                        <Gap height={10} />
                        <GridInline width={"100%"} paddingLeft={"5%"}>
                            <GridInline width={"30%"}>
                                Emotional Quotient
                                <br />
                                <small>(Kecerdasan Emosi)</small>
                            </GridInline>
                            <GridInline width={"27%"}>{dataPsi.skorEq}</GridInline>
                            <GridInline width={"35%"}>
                                <GridInline width={"5%"}>
                                    <img src="/assets/image/tinggi.png" width={"100%"} alt="" />
                                </GridInline>
                                <GridInline width={"2%"}></GridInline>
                                <GridInline width={"90%"}>{dataPsi.labelEq}</GridInline>
                            </GridInline>
                        </GridInline>
                        <Gap height={10} />
                        <Line color={"#E9ECEF"} />
                        <Gap height={10} />
                        <GridInline width={"100%"} paddingLeft={"5%"}>
                            <GridInline width={"30%"}>
                                Achievement MOTuotient
                                <br />
                                <small>(Motivasi Berprestasi)</small>
                            </GridInline>
                            <GridInline width={"27%"}>{dataPsi.skorAm}</GridInline>
                            <GridInline width={"35%"}>
                                <GridInline width={"5%"}>
                                    <img src="/assets/image/tinggi.png" width={"100%"} alt="" />
                                </GridInline>
                                <GridInline width={"2%"}></GridInline>
                                <GridInline width={"90%"}>{dataPsi.labelAm}</GridInline>
                            </GridInline>
                        </GridInline>
                        <Gap height={10} />
                        <Line color={"#E9ECEF"} />
                    </div>
                )}

                <div id="btn_print">
                    {this.state.showIndikator ? (
                        <div className="fixed_button">
                            <button className="btn btn-outline-primary btn133w pull-right" onClick={() => this.loadIndikator()}>
                                Hide Indikator
                            </button>
                            <button className="btn btn-outline-dark btn133w pull-right" style={{ marginRight: "1em" }} onClick={() => window.print()}>
                                Print
                            </button>
                        </div>
                    ) : (
                        <div className="fixed_button">
                            <button className="btn btn-outline-primary btn133w pull-right" onClick={() => this.loadIndikator()}>
                                Show Indikator
                            </button>
                            <button className="btn btn-outline-dark btn133w pull-right" style={{ marginRight: "1em" }} onClick={() => window.print()}>
                                Print
                            </button>
                        </div>
                    )}
                </div>

                {Object.keys(listIndikator).length != 0 && (
                    <>
                        {listIndikator.map(
                            (data, i) =>
                                data.indikators.length !== 0 && (
                                    <div className="report-page" key={i}>
                                        <div className="header-second-page">
                                            <GridInline width={"100%"}>
                                                <GridInline width={"80%"}>
                                                    {this.props.match.params.tipeCbt === "AGCU" ? (
                                                        <LabelTitle label={"Assessment Report Academic General Check-Up"} size={22} bolder={700} color={"#fff"} />
                                                    ) : (
                                                        <LabelTitle label={"Seleksi Nasional Berdasarkan Tes (SNBT)"} size={22} bolder={700} color={"#fff"} />
                                                    )}
                                                    <LabelTitle label={dataSekolah} size={18} bolder={500} color={"#fff"} />
                                                </GridInline>
                                            </GridInline>
                                        </div>

                                        <Gap height={30} />
                                        <div style={{ color: "#000", fontSize: 18, fontWeight: 600, marginBottom: 20 }}>{data.namaMapel}</div>

                                        <div className="table-responsive">
                                            <table className="table table-hover">
                                                <thead style={{ backgroundColor: "#F8F9FA" }}>
                                                    <th width="10%">Soal</th>
                                                    <th style={{ textAlign: "center" }}>Indikator</th>
                                                    <th width="15%" className="text-center">
                                                        Benar
                                                    </th>
                                                    <th width="15%" className="text-center">
                                                        Salah
                                                    </th>
                                                </thead>

                                                {this.renderIndikator(data.indikators)}
                                            </table>
                                        </div>
                                    </div>
                                )
                        )}
                    </>
                )}
            </div>
        );
    }
}

export default ReportAgcu;
